import { Component, OnInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { HttpClient,HttpHeaders,HttpParams } from '@angular/common/http';
import {JwtHelperService} from '@auth0/angular-jwt';
@Component({
  // tslint:disable-next-line
  selector: 'body',
  template: '<router-outlet></router-outlet>'
})
export class AppComponent implements OnInit {
  constructor(private router: Router,private http: HttpClient,private jwtHelper: JwtHelperService) {
  
      
  
  }

  ngOnInit() {
      var ifhastoken=localStorage.getItem("reportauth");
       var expireDate = new Date();
  expireDate.setDate(expireDate.getDate() + 1);
      
      if(!ifhastoken){
       this.getNewToken();
         }else{
            if (this.jwtHelper.isTokenExpired(ifhastoken)) {
   this.getNewToken();
  } else {
      
  }  
             
         }
     
      
   
  }
    
    getNewToken(){
           this.http.post("http://api.getback.health/api/UserAuth",{
        "UserName": "adam@healthybacksolutions.com.au",
        "PublicKey": "88978FE2-73A9-456D-8A8B-F2D92092E045",
        "IsAdmin": 0
}).subscribe(data=>{
        if(data["token"]){
           localStorage.setItem("reportauth",data["token"]);
            location.reload();
           }
          
      });
    }
}
